import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import LinearProgress from '@material-ui/core/LinearProgress'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import Button from '@material-ui/core/Button'
import { scrollToTop } from '../../utils/scrollTo'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { Translation } from 'react-i18next'
import store from '../../store'
import InvoicePdf from '../../containers/invoice/invoicePdf.container'
import AttachedJournalDocument from './attachedJournalPdf.component'
import { showInvoiceFormDialog } from '../../actions'
import { useDispatch, useSelector } from 'react-redux'

class InvoiceReview extends React.Component {
  componentDidMount() {
    this.props.getLogo()
    this.props.getUserCompanyUpdateInfo()
    scrollToTop()
  }

  render() {
    return <Review {...this.props} />
  }
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1)
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  radioButton: {
    fontSize: '15px',
    fontWeight: 'normal',
    color: '#808080'
  },
  progress: {
    flexGrow: 1
  },
  checkbox: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  }
})

const Review = ({
  files,
  removeInvoiceAttachments,
  InvokeExpenseReminder,
  isExpenseReminder,
  saveAndSendInvoicePDF,
  apiSuccess,
  closeSnackbar,
  apiFailed,
  limitExceedError,
  navigateToUpdateBankInfo,
  cancelExpenseReminder,
  saveInvoiceDraft,
  apiSendSuccess,
  showSpinner,
  invoice,
  cancelEditInvoice,
  loadInvoiceItems,
  editAndGoToInvoice,
  classes,
  logo,
  attachedWorkshiftJournal, // Journal id list
  attachedWorkshiftJournal_data,
  getAttachedJournalPdfData,
  invoice_lang,
  isAddWorkshiftJournal
}) => {
  const [pdfDataUri, setPdfDataUri] = React.useState(null) // Journal pdf data
  const history = useHistory()
  const dispatch = useDispatch()

  // These values are necessary to properly set the invoice into edit mode (isEdit: true)
  // For more details, see EDIT_AND_GO_TO_INVOICE in invoice.reducer
  const invoiceEditValues = useSelector((store) => store.invoice.invoiceEdit)

  const reopenInvoiceModalWithFinalStep = (data) => {
    sessionStorage.setItem(
      'reopenInvoiceModalWithFinalStep',
      JSON.stringify(data)
    )
    dispatch(showInvoiceFormDialog())
  }

  useEffect(() => {
    if (apiSendSuccess) {
      reopenInvoiceModalWithFinalStep()
      closeSnackbar()
      cancelEditInvoice()
      history.push('/dashboard/invoice')
    }
  }, [apiSendSuccess])

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('invoiceReview.h1')}</h1>
              </div>
            </div>
            <InvoicePdf logo={logo} />
            {files.length > 0 ? (
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('invoice.attachmentTitle')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        <div>
                          <aside>
                            <ul>
                              {files.map((file) => (
                                <li
                                  key={file}
                                  style={{
                                    display: 'block',
                                    position: 'relative',
                                    float: 'left',
                                    textAlign: 'center',
                                    color: 'rgba(0, 0, 0, 0.38)'
                                  }}
                                >
                                  {file}
                                </li>
                              ))}
                            </ul>
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {isAddWorkshiftJournal && attachedWorkshiftJournal.length > 0 ? (
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('ws_journal.title1')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        <div>
                          <b>{t('ws_journal.title1')}</b>: <br />
                          {attachedWorkshiftJournal.join(', ')}
                        </div>
                        <AttachedJournalDocument
                          data={attachedWorkshiftJournal_data}
                          t={t}
                          pdfDataUri={pdfDataUri}
                          setPdfDataUri={setPdfDataUri}
                          invoice_lang={invoice_lang}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <div
              className="row"
              style={{ textAlign: 'center', marginRight: '-7px' }}
            >
              <div className={!!invoice?.rows ? 'pull-right' : null}>
                {invoice?.rows ? (
                  <div>
                    <Button
                      variant="outlined"
                      className={classes.button}
                      onClick={() => editAndGoToInvoice(invoice, invoiceEditValues)}
                    >
                      {t('invoiceReview.button1')}
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.button}
                      onClick={() => saveInvoiceDraft(invoice)}
                    >
                      {t('invoiceReview.button')}
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      onClick={() => {
                        getAttachedJournalPdfData(pdfDataUri)
                        InvokeExpenseReminder()
                      }}
                    >
                      {t('invoiceReview.button2')}
                    </Button>
                  </div>
                ) : (
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => {
                      removeInvoiceAttachments()
                      history.push('/dashboard/invoice')
                      loadInvoiceItems()
                    }}
                  >
                    {t('invoice.header2')}
                  </Button>
                )}
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              //Huy Kas-157 kas-185
              open={
                apiSuccess &&
                store.getState().profile.userData.account_number !== null
              }
              autoHideDuration={4000}
              onClose={(e) => {
                closeSnackbar()
                cancelEditInvoice(e)
                history.push('/dashboard/invoice')
              }}
            >
              <MySnackbarContentWrapper
                onClose={(e) => {
                  closeSnackbar()
                  cancelEditInvoice(e)
                  history.push('/dashboard/invoice')
                }}
                variant="success"
                message={t('invoiceReview.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={apiFailed}
              autoHideDuration={4000}
              onClose={(e) => {
                closeSnackbar()
                cancelEditInvoice(e)
                history.push('/dashboard/invoice')
              }}
            >
              <MySnackbarContentWrapper
                onClose={(e) => {
                  closeSnackbar()
                  cancelEditInvoice(e)
                  history.push('/dashboard/invoice')
                }}
                variant="error"
                message={t('invoiceReview.failMsg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={limitExceedError}
              autoHideDuration={4000}
              onClose={(e) => {
                closeSnackbar()
                cancelEditInvoice(e)
                history.push('/dashboard/invoice')
              }}
            >
              <MySnackbarContentWrapper
                onClose={(e) => {
                  closeSnackbar()
                  cancelEditInvoice(e)
                  history.push('/dashboard/invoice')
                }}
                variant="error"
                message={t('invoiceReview.limitExceedFailMsg')}
              />
            </Snackbar>
            <Dialog
              open={showSpinner}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('invoiceReview.title')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
            <Dialog
              open={
                store.getState().profile.userData.account_number === null ||
                store.getState().profile.userData.account_number === ''
              }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('invoiceReview.dialogWarnTitle')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('invoiceReview.dialogWarnContent')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => {
                      navigateToUpdateBankInfo(invoice)
                    }}
                  >
                    {t('invoiceReview.warnButton')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={isExpenseReminder}
              onClose={() => cancelExpenseReminder()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('invoiceReview.isExpenseReminderTitle')}
                </span>
              </DialogTitle>

              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('invoiceReview.isExpenseReminderContent1')}
                  </span>
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => cancelExpenseReminder()}
                  >
                    {t('asiakkaat.dialogCancel')}
                  </Button>
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => saveInvoiceDraft(invoice)}
                  >
                    {t('invoiceReview.isExpenseReminderDraftButton')}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => saveAndSendInvoicePDF(invoice)}
                  >
                    {t('invoiceReview.isExpenseReminderButton')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

InvoiceReview.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvoiceReview)
